import { render } from "./TeacherLiteratureLibrary.vue?vue&type=template&id=23f34a6b&scoped=true"
import script from "./TeacherLiteratureLibrary.vue?vue&type=script&lang=js"
export * from "./TeacherLiteratureLibrary.vue?vue&type=script&lang=js"

import "./TeacherLiteratureLibrary.vue?vue&type=style&index=0&id=23f34a6b&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f34a6b"]])

export default __exports__